export default __webpack_public_path__ + "static/media/Nurses.2e410e96.png";